import { LocalizedString } from "app/shared/model/localized-string.model";

export interface MemberRegistration {
  id: string;
  memberId: string;
  period: string;
  inscriptionStatus: InscriptionStatus;
  exerciseStatus: ExerciseStatus;
  cancelled: boolean;
  memberPracticeTypeId: string;
  memberPracticeType: LocalizedString;
  validFrom: Date;
  validTo: Date;
  createdOn: Date;
}
export enum InscriptionStatus {
  Registered = 'Registered',
  NotRegistered = 'NotRegistered',
  PermanentNotRegistered = 'PermanentNotRegistered',
  NotAvailable = 'NotAvailable',
}

export enum ExerciseStatus {
  Active = 'Active',
  Inactive = 'Inactive',
  NotAvailable = 'NotAvailable',
}